template.load(function () {
    var $ = this.getLibrary('$');
    var bottomGap = 30;
    var minWidth = 721;
    var $fixedHeader = $('.c-header.c-header-template-1 .widget-view.widget-view-fixed');

    function getFixedHeaderHeight() {
        if (!$fixedHeader.length)
            return 0;

        if ($fixedHeader.css('display') === 'none')
            return 0;

        return $fixedHeader.outerHeight() || 0;
    }

    function updateCatalogSidebarOffset() {
        if (window.innerWidth < minWidth) {
            document.documentElement.style.removeProperty('--catalog-sidebar-sticky-top');
            return;
        }

        var offset = getFixedHeaderHeight() + bottomGap;

        document.documentElement.style.setProperty('--catalog-sidebar-sticky-top', offset + 'px');
    }

    $(window).on(
        'scroll.catalogSidebar resize.catalogSidebar catalog.sidebar.update',
        updateCatalogSidebarOffset
    );

    updateCatalogSidebarOffset();
}, {
    name: '[Custom] catalog sidebar sticky top',
    loader: {
        name: 'lazy'
    }
});
